import { relayPagination } from '@urql/exchange-graphcache/extras';

const paginationConfig = relayPagination({
  mergeMode: 'inwards',
});
const messagesConfig = relayPagination({
  mergeMode: 'outwards',
});

// Add Paginated Queries here
const resolvers = {
  Query: {
    latestMessagesByJobBasedOnUser: paginationConfig,
    onsiteDeviceFieldsFragment: paginationConfig,
    paginatedAttendance: paginationConfig,
    paginatedTransactions: paginationConfig,
    paginatedWorkersByStatus: paginationConfig,
    // NOTE: paginatedJobRequests is intentionally NOT merged here. Its consumers
    // (the Manage Jobs list and the bulk-edit modal) paginate page-by-page via
    // `withPagePagination`, because the merged read collapses to an empty list
    // when a lazy-loaded page's entity is garbage-collected on navigation. See
    // PHD-4793.
    paginatedWorkers: paginationConfig,
    paginatedTeams: paginationConfig,
    paginatedVenues: paginationConfig,
    paginatedTransactionDetails: paginationConfig,
    paginatedCustomJobReports: paginationConfig,
    paginatedPositions: paginationConfig,
    activePinJobs: paginationConfig,
    messages: messagesConfig,
    importedDrafts: paginationConfig,
    shifts: paginationConfig,
    paginatedDraftJobRequests: paginationConfig,
    paginatedRequestors: paginationConfig,
    workerSchedulesByPeriod: paginationConfig,
    paginatedWonoloers: paginationConfig
  },
};

export default resolvers;
